
import { UseFormReturn } from "react-hook-form";
import { ContractRemindersSection } from "./sections/ContractRemindersSection";
import { ContractFormValues } from "./ContractFormSchema";
import { FeatureGuard } from "@/components/common/FeatureGuard";
import { RemindersPreview } from "@/components/common/feature-previews/RemindersPreview";
import { useTranslation } from "react-i18next";

interface ContractRemindersProps {
  form: UseFormReturn<ContractFormValues>;
}

export function ContractReminders({ form }: ContractRemindersProps) {
  const { t } = useTranslation();
  
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium">{t('reminders', 'Reminders')}</h3>
        <p className="text-sm text-muted-foreground">
          {t('setupRemindersForContract', 'Set up reminders for this contract')}
        </p>
      </div>
      
      <FeatureGuard 
        feature="reminders" 
        showPreview={true}
        fallback={<RemindersPreview />}
      >
        <ContractRemindersSection form={form} />
      </FeatureGuard>
    </div>
  );
}
